import React from "react";

const Display = (props) => {
  return (
    <div className="display col-sm-12 col-md-3 .d-none">
      <div className="heading">
        <h1>2035</h1>

      </div>
    </div>
  );
}


export default Display;



// WEBPACK FOOTER //
// ./src/js/Display.jsx